import moment from 'moment';
import { TaskConversionProcessIssue } from '../model/entities';
import { syncApiAxios } from './CustomAxios';
import { Page } from '../model/elements';

class TaskConversionProcessIssueApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        taskProjectConversionProcessId: number,
        searchText?: string,
    ): Promise<Page<TaskConversionProcessIssue>> => {
        const response = await syncApiAxios.get<Page<TaskConversionProcessIssue>>('/task-conversion-process-issues', {
            params: { page, size, sortField, sortOrder, taskProjectConversionProcessId, searchText },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((d) => {
            d.audit!.created = d.audit!.created && moment.utc(d.audit!.created).local();
            d.audit!.updated = d.audit!.updated && moment.utc(d.audit!.updated).local();
        });

        return response.data;
    };

    get = async (id: number): Promise<TaskConversionProcessIssue> => {
        const response = await syncApiAxios.get<TaskConversionProcessIssue>(`/task-conversion-process-issues/${id}`);
        response.data.audit!.created = response.data.audit!.created && moment.utc(response.data.audit!.created).local();
        response.data.audit!.updated = response.data.audit!.updated && moment.utc(response.data.audit!.updated).local();

        return response.data;
    };
}

const taskConversionProcessIssueApi: TaskConversionProcessIssueApi = new TaskConversionProcessIssueApi();
export default taskConversionProcessIssueApi;
